import script from "./SuccessCases.vue?vue&type=script&lang=ts&setup=true"
export * from "./SuccessCases.vue?vue&type=script&lang=ts&setup=true"

import "./SuccessCases.vue?vue&type=style&index=0&id=5310ebb2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5310ebb2"]])

export default __exports__